import script from "./UploadFailTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadFailTable.vue?vue&type=script&lang=ts&setup=true"

import "./UploadFailTable.vue?vue&type=style&index=0&id=39bdd417&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39bdd417"]])

export default __exports__